module.exports = __webpack_public_path__ + "static/media/focusAudio.bf7a6d8b.m4a";